// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, setToken } from "../lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sid });
        // Persist token for iframe/third-party-cookie-blocked contexts (Emergent preview).
        if (r.data?.session_token) setToken(r.data.session_token);
        // Full-page navigation so the app boots fresh: the axios interceptor picks up
        // the localStorage token and /auth/me succeeds on first paint — no react-router
        // state hydration required. Also guarantees we're running the latest bundle.
        window.location.replace("/dashboard");
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("[AuthCallback] session exchange failed", e?.response?.status, e?.response?.data);
        const detail = e?.response?.data?.detail || "Sign-in failed. Please try again.";
        navigate("/login", { replace: true, state: { error: detail } });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB]" data-testid="auth-callback">
      <div className="text-slate-600 font-medium">Signing you in…</div>
    </div>
  );
}
